"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
const CardHeader = _ref => {
  let {
    className,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('cardHeader', className)
  }, children);
};
process.env.NODE_ENV !== "production" ? CardHeader.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node
} : void 0;
CardHeader.defaultProps = {
  className: undefined,
  children: undefined
};
var _default = exports.default = CardHeader;